import { Typography } from "@mui/material";
import React from "react";
import styles from "./DatePicker.module.css";
import DatePicker from "react-datepicker";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs';


function AppDatePicker({
  trigger,
  errors,
  name,
  required,
  label,
  setValue,
  value,
}) {


  return (
    <div>
      <div className={styles.heading}>
        <Typography>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </Typography>
      </div>
      <MobileDatePicker
         value={dayjs(value || null)}
        orientation="portrait"
        className={styles.calender}
        disableFuture
        format="DD/MM/YYYY"
        onChange={(date) => {
      
          setValue(name, date);
          trigger(name);
     
        }}
      />
   
      {errors && errors[name] && (
        <ValidationMessage message={errors[name]?.message} />
      )}
    </div>
  );
}

export default AppDatePicker;